module.exports = __webpack_public_path__ + "static/media/clipboard.a2d5b6cc.svg";